import { ServiceCostType } from "./service/model";
import { MoneyModel } from "./MoneyModel";
import { serviceModel } from '.';
import { sendErrReport } from "../infra/utils";
export let ActivityLogEntryType = /*#__PURE__*/function (ActivityLogEntryType) {
  ActivityLogEntryType["Relationship"] = "relationship";
  ActivityLogEntryType["Charge"] = "charge";
  ActivityLogEntryType["Invoice"] = "invoice";
  ActivityLogEntryType["Service"] = "service";
  return ActivityLogEntryType;
}({});
export let ActivityLogAgreementState = /*#__PURE__*/function (ActivityLogAgreementState) {
  ActivityLogAgreementState["Sent"] = "sent";
  ActivityLogAgreementState["Reviewed"] = "reviewed";
  ActivityLogAgreementState["MicroDepositStarted"] = "microDepositStarted";
  ActivityLogAgreementState["MicroDepositStartedV2"] = "microDepositStartedV2";
  ActivityLogAgreementState["MicroDeposit"] = "microDeposit";
  ActivityLogAgreementState["MicroDepositFailed"] = "microDepositFailed";
  ActivityLogAgreementState["MicroDepositFailedV2"] = "microDepositFailedV2";
  ActivityLogAgreementState["MicroDepositVerified"] = "microDepositVerified";
  ActivityLogAgreementState["MicroDepositVerifiedV2"] = "microDepositVerifiedV2";
  ActivityLogAgreementState["PaymentMethod"] = "paymentMethod";
  ActivityLogAgreementState["Approved"] = "approved";
  ActivityLogAgreementState["Terminated"] = "terminated";
  ActivityLogAgreementState["Changed"] = "changed";
  ActivityLogAgreementState["ChangesApproved"] = "changesApproved";
  ActivityLogAgreementState["ChangesAutoApproved"] = "changesAutoApproved";
  ActivityLogAgreementState["StoppedAutoApproval"] = "stoppedAutoApproval";
  ActivityLogAgreementState["SigningReminderSent"] = "signingReminderSent";
  ActivityLogAgreementState["SigningReminderSentManual"] = "signingReminderSentManual";
  ActivityLogAgreementState["MicroDepositReminderSent"] = "microDepositReminderSent";
  ActivityLogAgreementState["PaymentMethodChanged"] = "paymentMethodChanged";
  ActivityLogAgreementState["SignedExternally"] = "signedExternally";
  ActivityLogAgreementState["RequestedPaymentMethod"] = "requestedPaymentMethod";
  ActivityLogAgreementState["LegalTermsUpdated"] = "legalTermsUpdated";
  ActivityLogAgreementState["AmendmentsApprovalMethodUpdated"] = "amendmentsApprovalMethodUpdated";
  ActivityLogAgreementState["InvoicesApprovalMethodUpdated"] = "invoicesApprovalMethodUpdated";
  ActivityLogAgreementState["TitleUpdated"] = "titleUpdated";
  ActivityLogAgreementState["ManualPaymentsUpdated"] = "manualPaymentsUpdated";
  ActivityLogAgreementState["CoverCreditCardFeesUpdated"] = "coverCreditCardFeesUpdated";
  ActivityLogAgreementState["SellerUpdated"] = "sellerUpdated";
  ActivityLogAgreementState["PracticeManagementContactCreated"] = "practiceManagementContactCreated";
  ActivityLogAgreementState["PracticeManagementItemsCreated"] = "practiceManagementItemsCreated";
  ActivityLogAgreementState["PaymentMethodDisconnected"] = "paymentMethodDisconnected";
  return ActivityLogAgreementState;
}({});
export let ActivityLogChannel = /*#__PURE__*/function (ActivityLogChannel) {
  ActivityLogChannel["Email"] = "email";
  ActivityLogChannel["Sms"] = "sms";
  return ActivityLogChannel;
}({});
export let ActivityLogChargeState = /*#__PURE__*/function (ActivityLogChargeState) {
  ActivityLogChargeState["Created"] = "created";
  ActivityLogChargeState["Canceled"] = "canceled";
  ActivityLogChargeState["Approved"] = "approved";
  return ActivityLogChargeState;
}({});
export let ActivityLogInvoiceState = /*#__PURE__*/function (ActivityLogInvoiceState) {
  ActivityLogInvoiceState["Voided"] = "voided";
  ActivityLogInvoiceState["Completed"] = "completed";
  ActivityLogInvoiceState["IssuedIncomplete"] = "issuedIncomplete";
  ActivityLogInvoiceState["Issued"] = "issued";
  ActivityLogInvoiceState["PaymentFailed"] = "paymentFailed";
  ActivityLogInvoiceState["PaymentRetried"] = "paymentRetried";
  ActivityLogInvoiceState["Paid"] = "paid";
  ActivityLogInvoiceState["PaidExternally"] = "paidExternally";
  ActivityLogInvoiceState["DisputeResolved"] = "disputeResolved";
  ActivityLogInvoiceState["Approved"] = "approved";
  ActivityLogInvoiceState["Resent"] = "resent";
  ActivityLogInvoiceState["PaymentConfirmed"] = "paymentConfirmed";
  ActivityLogInvoiceState["PaymentProcessing"] = "paymentProcessing";
  ActivityLogInvoiceState["InvoiceIntegrationCreated"] = "invoiceIntegrationCreated";
  ActivityLogInvoiceState["InvoiceIntegrationSyncFailed"] = "invoiceIntegrationSyncFailed";
  ActivityLogInvoiceState["InvoiceIntegrationPaymentCreated"] = "invoiceIntegrationPaymentCreated";
  ActivityLogInvoiceState["InvoiceIntegrationPaymentSyncFailed"] = "invoiceIntegrationPaymentSyncFailed";
  ActivityLogInvoiceState["InvoiceIntegrationVoided"] = "invoiceIntegrationVoided";
  ActivityLogInvoiceState["Refunded"] = "refunded";
  ActivityLogInvoiceState["PaymentStoppedOLD"] = "disputed";
  ActivityLogInvoiceState["PaymentStopped"] = "paymentStopped";
  ActivityLogInvoiceState["PaymentResumed"] = "paymentResumed";
  ActivityLogInvoiceState["PaymentDisputed"] = "paymentDisputed";
  ActivityLogInvoiceState["RefundRequested"] = "refundRequested";
  ActivityLogInvoiceState["PaymentAutoApproved"] = "paymentAutoApproved";
  ActivityLogInvoiceState["AutoApprovalDisabled"] = "autoApprovalDisabled";
  ActivityLogInvoiceState["PayNowRequested"] = "payNowRequested";
  return ActivityLogInvoiceState;
}({});
export let ActivityLogServiceState = /*#__PURE__*/function (ActivityLogServiceState) {
  ActivityLogServiceState["Created"] = "created";
  ActivityLogServiceState["Changed"] = "changed";
  ActivityLogServiceState["Approved"] = "approved";
  ActivityLogServiceState["AutoApproved"] = "autoApproved";
  ActivityLogServiceState["ChangesApproved"] = "changesApproved";
  ActivityLogServiceState["ChangesAutoApproved"] = "changesAutoApproved";
  ActivityLogServiceState["Paused"] = "paused";
  ActivityLogServiceState["Resumed"] = "resumed";
  ActivityLogServiceState["Terminated"] = "terminated";
  ActivityLogServiceState["Canceled"] = "canceled";
  ActivityLogServiceState["BillCommandDeliverablesPendingApproval"] = "billCommandDeliverablesPendingApproval";
  ActivityLogServiceState["BillCommandDeliverablesApproved"] = "billCommandDeliverablesApproved";
  ActivityLogServiceState["BillCommandDeliverablesRejected"] = "billCommandDeliverablesRejected";
  ActivityLogServiceState["BillCommandDeliverablesWithdrawn"] = "billCommandDeliverablesWithdrawn";
  ActivityLogServiceState["ChangesDiscarded"] = "changesDiscarded";
  ActivityLogServiceState["PriceIncreased"] = "autoPriceIncreased";
  ActivityLogServiceState["IntegratedClassChanged"] = "integratedClassChanged";
  return ActivityLogServiceState;
}({});
export let ActivityLogPMIntegrationName = /*#__PURE__*/function (ActivityLogPMIntegrationName) {
  ActivityLogPMIntegrationName["Karbon"] = "karbon";
  ActivityLogPMIntegrationName["ClientHub"] = "client-hub";
  ActivityLogPMIntegrationName["FinancialCents"] = "financial-cents";
  return ActivityLogPMIntegrationName;
}({});
export class ActivityLogEntryModel {
  static make(dto) {
    switch (dto.type) {
      case ActivityLogEntryType.Relationship:
        return new ActivityLogAgreementEntryModel(dto);
      case ActivityLogEntryType.Charge:
        return new ActivityLogChargeEntryModel(dto);
      case ActivityLogEntryType.Invoice:
        return new ActivityLogInvoiceEntryModel(dto);
      case ActivityLogEntryType.Service:
        return new ActivityLogServiceEntryModel(dto);
    }
  }
  constructor(dto) {
    this.dto = dto;
    this.timestampAsDate = new Date(this.dto.timestamp);
  }
  isAgreementEntry() {
    return this.dto.type === ActivityLogEntryType.Relationship;
  }
  isServiceEntry() {
    return this.dto.type === ActivityLogEntryType.Service;
  }
  isChargeEntry() {
    return this.dto.type === ActivityLogEntryType.Charge;
  }
  isInvoiceEntry() {
    return this.dto.type === ActivityLogEntryType.Invoice;
  }
  id() {
    return this.dto.id;
  }
  state() {
    return this.dto.state;
  }
  timestamp() {
    return this.timestampAsDate;
  }
  vendorName() {
    var _this$dto$data$vendor;
    return (_this$dto$data$vendor = this.dto.data.vendor) === null || _this$dto$data$vendor === void 0 ? void 0 : _this$dto$data$vendor.name;
  }
  customerName() {
    var _this$dto$data$custom;
    return (_this$dto$data$custom = this.dto.data.customer) === null || _this$dto$data$custom === void 0 ? void 0 : _this$dto$data$custom.name;
  }
  switch(opts) {
    if (this.isAgreementEntry()) {
      return opts.whenAgreement(this);
    } else if (this.isChargeEntry()) {
      return opts.whenCharge(this);
    } else if (this.isInvoiceEntry()) {
      return opts.whenInvoice(this);
    } else if (this.isServiceEntry()) {
      return opts.whenService(this);
    } else {
      const err = new Error("Unknown entry type ".concat(this.dto.type));
      sendErrReport(err);
      throw err;
    }
  }
  customer() {
    return this.dto.data.customer;
  }
  vendor() {
    return this.dto.data.vendor;
  }
  customerNameAndEmail() {
    const customer = this.customer();
    return customer ? this.nameAndEmail(customer.name, customer.email) : '';
  }
  nameAndEmail(name, email) {
    return name ? email ? "".concat(name, " (").concat(email, ")") : name : '';
  }
}
export class ActivityLogAgreementEntryModel extends ActivityLogEntryModel {
  constructor(dto) {
    super(dto);
    this.agreementDTO = dto;
  }
  state() {
    return this.agreementDTO.state;
  }
  isReminderEntry() {
    return [ActivityLogAgreementState.SigningReminderSent, ActivityLogAgreementState.SigningReminderSentManual, ActivityLogAgreementState.MicroDepositReminderSent].includes(this.agreementDTO.state);
  }
  channel() {
    return this.agreementDTO.data.channel;
  }
  paymentMethod() {
    return this.agreementDTO.data.paymentMethod;
  }
  hasReviewers() {
    const reviewers = this.reviewers();
    return !!reviewers && reviewers.length > 0;
  }
  reviewerNamesAndEmails() {
    const reviewers = this.reviewers();
    return (reviewers || []).map(r => this.nameAndEmail(r.name, r.email));
  }
  netTermsChanges() {
    var _this$agreementDTO$da;
    return (_this$agreementDTO$da = this.agreementDTO.data.changes) === null || _this$agreementDTO$da === void 0 ? void 0 : _this$agreementDTO$da.netTerms;
  }
  amendmentsApprovalMethodChanges() {
    var _this$agreementDTO$da2;
    return (_this$agreementDTO$da2 = this.agreementDTO.data.changes) === null || _this$agreementDTO$da2 === void 0 ? void 0 : _this$agreementDTO$da2.amendmentsApprovalMethod;
  }
  invoicesApprovalMethodChanges() {
    var _this$agreementDTO$da3;
    return (_this$agreementDTO$da3 = this.agreementDTO.data.changes) === null || _this$agreementDTO$da3 === void 0 ? void 0 : _this$agreementDTO$da3.invoicesApprovalMethod;
  }
  titleChanges() {
    var _this$agreementDTO$da4;
    return (_this$agreementDTO$da4 = this.agreementDTO.data.changes) === null || _this$agreementDTO$da4 === void 0 ? void 0 : _this$agreementDTO$da4.title;
  }
  manualPaymentsChanges() {
    var _this$agreementDTO$da5;
    return (_this$agreementDTO$da5 = this.agreementDTO.data.changes) === null || _this$agreementDTO$da5 === void 0 ? void 0 : _this$agreementDTO$da5.manualPayments;
  }
  coverCCFeesChanges() {
    var _this$agreementDTO$da6;
    return (_this$agreementDTO$da6 = this.agreementDTO.data.changes) === null || _this$agreementDTO$da6 === void 0 ? void 0 : _this$agreementDTO$da6.coverCreditCardFees;
  }
  sellerChanges() {
    var _this$agreementDTO$da7;
    return (_this$agreementDTO$da7 = this.agreementDTO.data.changes) === null || _this$agreementDTO$da7 === void 0 ? void 0 : _this$agreementDTO$da7.seller;
  }
  integrationName() {
    return this.agreementDTO.data.integrationName;
  }
  integrationServices() {
    return this.agreementDTO.data.integrationServices;
  }
  reviewers() {
    return this.agreementDTO.data.reviewers;
  }
}
export class ActivityLogServiceEntryModel extends ActivityLogEntryModel {
  constructor(dto) {
    super(dto);
    this.serviceDTO = dto;
    const serviceChanges = dto.data.service.changes;
    if (serviceChanges !== null && serviceChanges !== void 0 && serviceChanges.cost) {
      this._serviceChangesCost = serviceModel.costFromDTO(serviceChanges.cost);
    }
    if (serviceChanges !== null && serviceChanges !== void 0 && serviceChanges.billing) {
      this._serviceChangesBilling = serviceModel.billingFromDTO(serviceChanges.billing);
    }
    const serviceBeforeChanges = dto.data.service.beforeChanges;
    if (serviceBeforeChanges !== null && serviceBeforeChanges !== void 0 && serviceBeforeChanges.cost) {
      this._serviceBeforeChangesCost = serviceModel.costFromDTO(serviceBeforeChanges.cost);
    }
  }
  hasChanges() {
    return !!this.serviceDTO.data.service.changes;
  }
  descriptionChange() {
    var _this$serviceDTO$data;
    return (_this$serviceDTO$data = this.serviceDTO.data.service.changes) === null || _this$serviceDTO$data === void 0 ? void 0 : _this$serviceDTO$data.description;
  }
  serviceChangesCost() {
    return this._serviceChangesCost;
  }
  priceChange() {
    const cost = this.serviceChangesCost();
    if (!(cost !== null && cost !== void 0 && cost.pricingType)) return null;
    switch (cost.pricingType) {
      case ServiceCostType.Fixed:
      case ServiceCostType.Variable:
        return cost.price;
      case ServiceCostType.Range:
        return cost.maxPrice;
    }
  }
  priceBeforeChange() {
    var _this$_serviceBeforeC;
    if (!((_this$_serviceBeforeC = this._serviceBeforeChangesCost) !== null && _this$_serviceBeforeC !== void 0 && _this$_serviceBeforeC.pricingType)) return null;
    switch (this._serviceBeforeChangesCost.pricingType) {
      case ServiceCostType.Fixed:
      case ServiceCostType.Variable:
        return this._serviceBeforeChangesCost.price;
      case ServiceCostType.Range:
        return this._serviceBeforeChangesCost.maxPrice;
    }
  }
  integratedClassNameChange() {
    var _this$serviceDTO$data2;
    return ((_this$serviceDTO$data2 = this.serviceDTO.data.service.changes) === null || _this$serviceDTO$data2 === void 0 || (_this$serviceDTO$data2 = _this$serviceDTO$data2.integratedClass) === null || _this$serviceDTO$data2 === void 0 ? void 0 : _this$serviceDTO$data2.name) || null;
  }
  integratedClassNameBeforeChange() {
    var _this$serviceDTO$data3;
    return ((_this$serviceDTO$data3 = this.serviceDTO.data.service.beforeChanges) === null || _this$serviceDTO$data3 === void 0 || (_this$serviceDTO$data3 = _this$serviceDTO$data3.integratedClass) === null || _this$serviceDTO$data3 === void 0 ? void 0 : _this$serviceDTO$data3.name) || null;
  }
  billingChange() {
    return this._serviceChangesBilling;
  }
  note() {
    return this.serviceDTO.data.service.note;
  }
  name() {
    return this.serviceDTO.data.service.name;
  }
}
export class ActivityLogChargeEntryModel extends ActivityLogEntryModel {
  constructor(dto) {
    super(dto);
    this.chargeDTO = dto;
    this.price = MoneyModel.fromDTO(dto.data.charge.temp_price);
  }
  name() {
    return this.chargeDTO.data.charge.name;
  }
  note() {
    return this.chargeDTO.data.charge.note;
  }
  formattedPrice() {
    return this.price.display();
  }
}
export class ActivityLogInvoiceEntryModel extends ActivityLogEntryModel {
  constructor(dto) {
    super(dto);
    this.invoiceDTO = dto;
    this.totalAmountAsMoney = MoneyModel.fromDTO(dto.data.invoice.totalAmount);
  }
  invoiceId() {
    return this.invoiceDTO.data.invoice.id;
  }
  formattedNumber() {
    return this.invoiceDTO.data.invoice.formattedNumber;
  }
  totalAmount() {
    return this.totalAmountAsMoney;
  }
  paymentStoppedReason() {
    var _this$invoiceDTO$data;
    return (_this$invoiceDTO$data = this.invoiceDTO.data.paymentStopped) === null || _this$invoiceDTO$data === void 0 ? void 0 : _this$invoiceDTO$data.reason;
  }
  refundRequestedReason() {
    var _this$invoiceDTO$data2;
    return (_this$invoiceDTO$data2 = this.invoiceDTO.data.refundRequested) === null || _this$invoiceDTO$data2 === void 0 ? void 0 : _this$invoiceDTO$data2.reason;
  }
}